<template>
  <div class="classify">
    <div class="addbox">
      <el-button class="add-btn" icon="el-icon-plus" @click="goEdit('add', 1)"
        >添加一级分类</el-button
      >
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        :expand-row-keys="expands"
        row-key="id"
      >
        <el-table-column type="expand" width="1">
          <template slot-scope="parent">
            <el-table :data="parent.row.children" :show-header="false">
              <el-table-column label="分类名称" prop="name">
                <template slot-scope="{ row }">
                  <div class="children-name">{{ row.name }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="status_dictText" label="状态">
                <template slot-scope="{ row }">
                  <el-button
                    :class="row.status === 0 ? 'success-btn' : 'fail-btn'"
                    >{{ row.status === 0 ? "启用" : "禁用" }}</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column label="图标" prop="icon">
                <template slot-scope="{ row }">
                  <div class="icon">
                    <img :src="row.icon" alt="" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="是否展示首页"
                prop="recommendShow_dictText"
              >
                <template>
                  <span>-</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="120">
                <template slot-scope="scope">
                  <el-button
                    class="textOrange-btn"
                    @click="goEdit('edit', 2, parent.row.id, scope.row)"
                    >编辑</el-button
                  >
                  <el-popconfirm
                    title="是否启用该二级分类？"
                    popper-class="customerdel-popover"
                    @confirm="cancelOrder(scope.row, 0, 2, parent)"
                    v-if="Number(scope.row.status) === 1"
                    style="margin-left: 8px"
                  >
                    <el-button class="textOrange-btn" slot="reference"
                      >启用</el-button
                    >
                  </el-popconfirm>
                  <el-popconfirm
                    title="是否禁用该二级分类？"
                    popper-class="customerdel-popover"
                    @confirm="cancelOrder(scope.row, 1, 2, parent)"
                    v-if="Number(scope.row.status) === 0"
                    style="margin-left: 8px"
                  >
                    <el-button class="textOrange-btn" slot="reference"
                      >禁用</el-button
                    >
                  </el-popconfirm>
                  <el-popconfirm
                    title="是否删除该二级分类？"
                    popper-class="customerdel-popover"
                    @confirm="deleteFn(scope.row.id, 2, parent)"
                    style="margin-left: 8px"
                  >
                    <el-button class="textOrange-btn" slot="reference"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="分类名称" prop="name">
          <template slot-scope="{ row, $index }">
            <div class="name">
              <img
                @click="handleRowClick(row, $index)"
                :src="
                  row.id == expands.filter((val) => val == row.id)
                    ? require('@/assets/shop/minus.png')
                    : require('@/assets/shop/plus.png')
                "
                alt=""
              />
              <span>{{ row.name }}</span>
              <el-button
                class="textOrange-btn"
                @click="goEdit('add', 2, row.id)"
                >添加二级分类</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status_dictText" label="状态">
          <template slot-scope="{ row }">
            <el-button :class="row.status === 0 ? 'success-btn' : 'fail-btn'">{{
              row.status === 0 ? "启用" : "禁用"
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="图标" prop="icon">
          <template slot-scope="{ row }">
            <div class="icon">
              <img :src="row.icon" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否展示首页" prop="recommendShow_dictText">
          <template slot-scope="{ row }">
            <span>{{ row.recommendShow === 1 ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button
              class="textOrange-btn"
              @click="goEdit('edit', 1, scope.row.id, scope.row)"
              >编辑</el-button
            >
            <el-popconfirm
              title="是否隐藏首页展示？"
              popper-class="customerdel-popover"
              @confirm="goodsShow(scope.row, 0)"
              v-if="Number(scope.row.recommendShow) === 1"
              style="margin-left: 8px"
            >
              <el-button class="textOrange-btn" slot="reference"
                >隐藏首页</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              title="是否首页展示？"
              popper-class="customerdel-popover"
              @confirm="goodsShow(scope.row, 1)"
              v-if="Number(scope.row.recommendShow) === 0"
              style="margin-left: 8px"
            >
              <el-button class="textOrange-btn" slot="reference"
                >展示首页</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              title="是否启用该一级分类？"
              popper-class="customerdel-popover"
              @confirm="cancelOrder(scope.row, 0, 1)"
              v-if="Number(scope.row.status) === 1"
              style="margin-left: 8px"
            >
              <el-button class="textOrange-btn" slot="reference"
                >启用</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              title="是否禁用该一级分类？"
              popper-class="customerdel-popover"
              @confirm="cancelOrder(scope.row, 1, 1)"
              v-if="Number(scope.row.status) === 0"
              style="margin-left: 8px"
            >
              <el-button class="textOrange-btn" slot="reference"
                >禁用</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              title="是否删除该一级分类？"
              popper-class="customerdel-popover"
              @confirm="deleteFn(scope.row.id, 1)"
              style="margin-left: 8px"
            >
              <el-button class="textOrange-btn" slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  getClassifyList,
  editClassifyStatus,
  editClassifyShow,
  deleteClassify,
} from "@/api/shop";
export default {
  data() {
    return {
      queryParams: {
        parentId: "",
      },
      tableData: [],
      expands: [],
      // total: 0, //总数
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取商品分类列表
    async init() {
      const res = await getClassifyList(this.queryParams);
      this.tableData = res.result;
      // this.total = res.result.total;
    },
    async handleRowClick(row, index) {
      // console.log("row,index :>> ", row, index);
      if (this.expands.includes(row.id)) {
        this.expands = this.expands.filter((val) => val !== row.id);
      } else {
        this.queryParams.parentId = row.id;
        const res = await getClassifyList(this.queryParams);
        this.tableData[index].children = res.result;
        this.expands.push(row.id);
      }
    },
    // 添加/修改分类
    goEdit(type, classnumber, id, row) {
      if (type === "add") {
        this.$router.push({
          path: "/classify",
          query: {
            type,
            classnumber,
            id,
          },
        });
        return;
      }
      localStorage.setItem("classify", JSON.stringify(row));
      this.$router.push({
        path: "/classify",
        query: {
          type,
          classnumber,
          id,
        },
      });
    },
    // 去修改
    // goEdit(item) {
    //   localStorage.setItem("bannerInfo", JSON.stringify(item));
    //   this.$router.push({
    //     path: "/addpaper",
    //     query: {
    //       type: "edit",
    //     },
    //   });
    // },
    //修改分类 状态
    async cancelOrder(item, status, type, row) {
      if (type === 2) {
        this.queryParams.parentId = row.row.id;
        const params = {
          status,
          id: item.id,
        };
        await editClassifyStatus(params);
        const res = await getClassifyList(this.queryParams);
        this.tableData[row.$index].children = res.result;
        this.tableData = JSON.parse(JSON.stringify(this.tableData));
        return;
      }
      const params = {
        status,
        id: item.id,
      };
      await editClassifyStatus(params);
      this.queryParams.parentId = "";
      this.expands = [];
      this.init();
    },
    // 推荐/取消显示商品分类
    async goodsShow(item, recommendShow) {
      const params = {
        recommendShow,
        id: item.id,
      };
      await editClassifyShow(params);
      this.queryParams.parentId = "";
      this.expands = [];
      // this.$refs[`${text}-popover-${index}`].doClose();
      this.init();
    },
    // 删除分类
    async deleteFn(id, type, row) {
      if (type === 2) {
        this.queryParams.parentId = row.row.id;
        const params = {
          id,
        };
        await deleteClassify(params);
        this.$message.success("删除成功！");
        const res = await getClassifyList(this.queryParams);
        this.tableData[row.$index].children = res.result;
        this.tableData = JSON.parse(JSON.stringify(this.tableData));
        return;
      }
      const params = {
        id,
      };
      await deleteClassify(params);
      this.$message.success("删除成功！");
      this.queryParams.parentId = "";
      this.expands = [];
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.classify {
  position: relative;
  .addbox {
    position: absolute;
    top: -88px;
    right: 0;
  }
  .content {
    // .textOrange-btn {
    //   margin: 0 10px;
    // }
    ::v-deep .el-table {
      .el-table__expand-icon {
        display: none;
      }
      .name {
        display: flex;
        align-items: center;
        span {
          display: block;
          min-width: 60px;
        }
        img {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }
        .textOrange-btn {
          margin-left: 18px;
        }
      }
      .icon {
        width: 44px;
        height: 44px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 100%;
        }
      }
      .el-table__expanded-cell {
        background: #fafafa;
        // box-shadow: inset 0px -1px 0px 0px #f0f0f0;
        padding: 0;
        border: none;
        .el-table__row {
          background: #fafafa;
        }
        .children-name {
          text-align: right;
          padding-right: 28px;
        }
      }
    }
  }
}
</style>
